import { useFlags } from "features/api/flags"

export function useDeliveriesFlag(): {
  isDeliveriesEnabled: boolean
} {
  const { DELIVERIES } = useFlags()
  return { isDeliveriesEnabled: DELIVERIES.boolVal }
}
